import { render, staticRenderFns } from "./ButtonBig.vue?vue&type=template&id=e7caba08&"
import script from "./ButtonBig.vue?vue&type=script&lang=js&"
export * from "./ButtonBig.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports